<template>
  <!-- <div class="layout"> -->
    <v-layout full-height="true">
      <AppDrawer />
      <v-main>
        <slot></slot>
      </v-main>
      <AppNav />
      <!-- [matrah] legacy: <AppFooter /> (was disabled) -->
      <AppFooter />
    </v-layout>
  <!-- </div>/ -->
</template>

<script>
import AppNav from "./AppNav";
import AppDrawer from "./AppDrawer";
// [matrah] legacy: // import AppFooter from "./AppFooter";
import AppFooter from "./AppFooter";
export default {
  components: {
    AppNav,
    // [matrah] legacy: // AppFooter,
    AppFooter,
    AppDrawer,
  },
  data: () => ({
    drawer: false,
  }),
};
</script>
